import { createContext, useContext } from "react";

import type { ButtonProps } from "./Button.types";

type ButtonContextValue = Pick<ButtonProps, "variant">;

export function makeButtonContext({
  variant = "primary",
}: ButtonContextValue): Required<ButtonContextValue> {
  return { variant };
}

export const ButtonContext = createContext<
  Required<ButtonContextValue> | undefined
>(undefined);

export function useButtonContext() {
  return useContext(ButtonContext);
}
